import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Profile", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold" }, "Employment Status Display", -1)
const _hoisted_3 = { class: "flex flex-col gap-2 mt-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Current employment status (Required)", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Years of experience", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Company name", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Company location", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Title (Required)", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Field of practice", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Open to", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-grow min-h-50" }, null, -1)
const _hoisted_12 = { class: "sticky flex bottom-0 z-100 w-full p-2 bg-white shadow-md dark:bg-primary-black" }

import { arrowBackCircle } from "ionicons/icons"
  import { IonBackButton } from "@ionic/vue"
  import { ref, computed, onMounted } from "vue"
  import { useAccountStore } from "@/store/account"
  import { useUserStore } from "@/store/user"
  import { useResourcesStore } from "@/store/resources"
  import { generateSchema } from "@/utils/validate"
  import { filter } from "lodash"
  import jwt from "@/utils/jwt"

  import CardTemplate from "@/components/template/CardTemplate.vue"
  import WbInput from "@/components/template/InputTemplate.vue"
  import SelectTemplate from "@/components/template/SelectTemplate.vue"
  import FormTemplate from "@/components/template/formTemplate.vue"
  import WbMultipleSelect from "@/components/template/ComboBoxContainer.vue"
  import LocationTemplate from "@/components/template/locationTemplate.vue"

  // initialize stores
  
export default /*#__PURE__*/_defineComponent({
  __name: 'EmploymentStatus',
  setup(__props) {

  const accountStore = useAccountStore()
  const userStore = useUserStore()
  const resourceStore = useResourcesStore()

  // initilize resources
  const nbf = ref(jwt.generateNBF())
  const disableEdit = computed(() => (accountStore.type === "professional" ? false : true))
  const industries = computed<any>(() =>
    resourceStore.industries.map((val: any) => {
      return { name: val.name, value: val.id }
    })
  )
  const profile = computed<any>({
    get: () => userStore.customerDetails.profile,
    set: (val) => userStore.setCustomerDetails({ profile: val }),
  })
  const visibility = computed<any>(() => userStore.customerDetails.profile.visibility)
  const employmentStatusList = ["Actively seeking new opportunity", "Quietly seeking new opportunity", "Happily Employed", "Not looking for anything"]
  const workSetupOption = [
    { name: "Office", value: "office" },
    { name: "Remote", value: "remote" },
    { name: "Relocation", value: "relocation" },
  ]
  const companyAddress = ref({
    country: "",
    city: "",
    full_address: "",
  })
  const input = ref({
    role: "",
    status: "",
    years_exp: "",
    work_setup: [] as string[],
    company: "",
    company_location: "",
    industry: 0,
  })

  /**
   * initial data and schema
   */
  const employmentDetails = computed(() => ({
    role: profile.value.employment.role,
    status: visibility.value?.includes("status") ? profile.value.employment.status : "",
    years_exp: visibility.value?.includes("years_exp") ? profile.value.employment.years_exp : "",
    work_setup: visibility.value?.includes("work_setup") ? profile.value.employment.work_setup : [],
    company: visibility.value?.includes("company") ? profile.value.employment.company : "",
    company_location: visibility.value?.includes("company_location") ? profile.value.employment.company_location.full_address : "",
    industry: visibility.value?.includes("industry") ? profile.value.employment.industry?.id : 0,
  }))
  const employmentSchema = generateSchema([
    {
      name: "role",
      rule: "stringRequired",
    },
  ])

  /**
   * set company location
   */
  const setCompanyLocation = (val: any) => {
    companyAddress.value = val
    input.value.company_location = val.full_address
  }

  /**
   * save employment details
   */
  const saveEmploymentDetails = () => {
    // list of visibility
    let visibilityList = visibility.value
    profile.value.employment.role = input.value.role

    // set status visibility
    if (input.value.status.length) {
      profile.value.employment.status = input.value.status
      if (!visibilityList?.includes("status")) visibilityList?.push("status")
    } else if (visibilityList?.includes("status")) {
      visibilityList = filter(visibilityList, (item) => item != "status")
    }

    // set years_exp visibility
    if (input.value.years_exp != null && input.value.years_exp != "") {
      profile.value.employment.years_exp = parseInt(input.value.years_exp, 10)
      if (!visibilityList?.includes("years_exp")) visibilityList?.push("years_exp")
    } else if (visibilityList?.includes("years_exp")) {
      visibilityList = filter(visibilityList, (item) => item != "years_exp")
    }

    // set company visibility
    if (input.value.company.length) {
      profile.value.employment.company = input.value.company
      if (!visibilityList?.includes("company")) visibilityList?.push("company")
    } else if (visibilityList?.includes("company")) {
      visibilityList = filter(visibilityList, (item) => item != "company")
    }

    // set company_location visibility
    if (input.value.company_location.length) {
      profile.value.employment.company_location = companyAddress.value
      if (!visibilityList?.includes("company_location")) visibilityList?.push("company_location")
    } else if (visibilityList?.includes("company_location")) {
      visibilityList = filter(visibilityList, (item) => item != "company_location")
    }

    // set industry visibility
    if (input.value.industry > 0) {
      profile.value.employment.industry = { id: input.value.industry }
      if (!visibilityList?.includes("industry")) visibilityList?.push("industry")
    } else if (visibilityList?.includes("industry")) {
      visibilityList = filter(visibilityList, (item) => item != "industry")
    }

    // set work_setup visibility
    if (input.value.work_setup.length) {
      profile.value.employment.work_setup = input.value.work_setup
      if (!visibilityList?.includes("work_setup")) visibilityList?.push("work_setup")
    } else if (visibilityList?.includes("work_setup")) {
      visibilityList = filter(visibilityList, (item) => item != "work_setup")
    }

    // set details visibility
    profile.value.visibility = visibilityList

    const employmentData = {
      profile: {
        employment: profile.value.employment,
        visibility: profile.value.visibility,
      },
    }
    userStore.saveCustomerDetails(nbf.value, employmentData)
    userStore.retrieveProfileDetails("employment")
  }

  onMounted(() => {
    resourceStore.retrieveIndustries()
    userStore.retrieveProfileDetails("employment")
    input.value = {
      ...input.value,
      ...employmentDetails.value,
    }
    if (employmentDetails.value.company_location.length) companyAddress.value = profile.value.employment.company_location
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonBackButton), {
                  class: "text-gray-300 pl-3",
                  text: ``,
                  icon: _unref(arrowBackCircle)
                }, null, 8, ["icon"]),
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createVNode(FormTemplate, {
          "validation-schema": _unref(employmentSchema),
          "initial-values": JSON.parse(JSON.stringify(_unref(employmentDetails))),
          class: "flex flex-col min-h-screen",
          onValid: saveEmploymentDetails
        }, {
          default: _withCtx(() => [
            _createVNode(CardTemplate, { class: "mx-4 my-6" }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(WbMultipleSelect, {
                    modelValue: input.value.status,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input.value.status) = $event)),
                    name: "status",
                    data: employmentStatusList,
                    type: "default",
                    "input-disabled": true,
                    "has-visibility": true,
                    placeholder: "Your employment status"
                  }, null, 8, ["modelValue"]),
                  _hoisted_5,
                  _createVNode(WbInput, {
                    modelValue: input.value.years_exp,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((input.value.years_exp) = $event)),
                    name: "years_exp",
                    type: "number",
                    min: 1,
                    placeholder: "Do not display"
                  }, null, 8, ["modelValue"]),
                  _hoisted_6,
                  _createVNode(WbInput, {
                    modelValue: input.value.company,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((input.value.company) = $event)),
                    name: "company",
                    type: "text",
                    placeholder: "Do not display",
                    disabled: _unref(disableEdit)
                  }, null, 8, ["modelValue", "disabled"]),
                  _hoisted_7,
                  _createVNode(LocationTemplate, {
                    modelValue: input.value.company_location,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((input.value.company_location) = $event)),
                    name: "company_location",
                    disabled: _unref(disableEdit),
                    placeholder: "Do not display",
                    "floating-suggestions": false,
                    onLocation: setCompanyLocation
                  }, null, 8, ["modelValue", "disabled"]),
                  _hoisted_8,
                  _createVNode(WbInput, {
                    modelValue: input.value.role,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((input.value.role) = $event)),
                    name: "role",
                    type: "text",
                    placeholder: "Title"
                  }, null, 8, ["modelValue"]),
                  _hoisted_9,
                  _createVNode(WbMultipleSelect, {
                    modelValue: input.value.industry,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((input.value.industry) = $event)),
                    name: "industry",
                    data: _unref(industries),
                    type: "default",
                    "display-selected-names": true,
                    "by-value": true,
                    "input-disabled": true,
                    "capitalized-input-display": true,
                    "has-visibility": true,
                    placeholder: "Industry you belong to"
                  }, null, 8, ["modelValue", "data"]),
                  _hoisted_10,
                  _createVNode(WbMultipleSelect, {
                    modelValue: input.value.work_setup,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((input.value.work_setup) = $event)),
                    name: "work_setup",
                    multiple: true,
                    data: workSetupOption,
                    type: "default",
                    "by-value": true,
                    "input-disabled": true,
                    "capitalized-input-display": true,
                    "has-visibility": true,
                    placeholder: "Select work setup"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_ion_button, {
                expand: "block",
                color: "white",
                type: "submit",
                "native-type": "submit",
                class: "text-white bg-primary-violet font-bold rounded-[4px] shadow-base w-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Save")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["validation-schema", "initial-values"])
      ]),
      _: 1
    })
  ], 64))
}
}

})